// Shared image assets. The object paths and ?token= values are the original's,
// but the bucket is this project's own `online-pos-7a275` - the retired
// prod-managesome project is no longer referenced. Every object below was
// copied across by mongo-api/scripts/migrate-storage-old-to-new.mjs and is
// served publicly from the new bucket.
// The bucket/host half is NOT written here: it comes from
// NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET (or
// NEXT_PUBLIC_FIREBASE_STORAGE_MEDIA_BASE_URL) via firebaseMediaUrl(), so a
// bucket change is one .env edit rather than a grep across the source. Only the
// object path and its download token — per-asset facts, not environment facts —
// stay in this file.
import { firebaseMediaUrl } from "../lib/config";

const BUCKET_FOLDER = "images%2Fcommon%2F";
const BUCKET = `${firebaseMediaUrl(BUCKET_FOLDER)}`;

export const NO_DISPLAY_IMAGE = `${BUCKET}no-display.png?alt=media&token=ee0af5d6-1a1c-4339-9f8f-9d89230d45e8`;
export const DEFAULT_WEB_COVER = `${BUCKET}DEFAULT_WEB_COVER.jpg?alt=media&token=452022dc-8f04-44dc-8f38-c4255934fbfe`;
export const DEFAULT_BACKGROUND = `${BUCKET}DEFAULT_BACKGROUND.jpg?alt=media&token=62ceeb36-67ce-4309-8320-5a41312b49e3`;
export const DEFAULT_UPLOAD_IMAGE = `${BUCKET}default-upload-image.jpg?alt=media&token=de09752e-dccb-48c0-a6eb-910d30d6b489`;

export const PLAY_STORE_BADGE = `${BUCKET}GET_IT_ON_PLAYSTORE.png?alt=media&token=307667a1-32fc-4996-ab35-922bd647c3db`;
export const APP_STORE_BADGE = `${BUCKET}GET_IN_ON_APPSTORE.png?alt=media&token=21830e51-610a-4112-a160-24df2d169937`;

export const MASTER_CARD = `${BUCKET}MASTER_CARD.jpg?alt=media&token=203af990-680e-4465-9ab9-f44cda293dac`;
export const VISA_CARD = `${BUCKET}VISA_CARD.jpg?alt=media&token=5abac405-5dc4-4a5b-a4de-940925e5491b`;
export const AMEX_CARD = `${BUCKET}AMEX_CARD.jpg?alt=media&token=d3bda414-b903-41df-9da1-3cfc39a883fd`;
export const EASYPAISA = `${BUCKET}EASYPAISA.png?alt=media&token=567e67b8-0817-489f-bd36-62bd1fac8d07`;
export const JAZZCASH = `${BUCKET}JAZZCASH.png?alt=media&token=abe88ec2-d5fc-4542-8fe7-d531dff9e79a`;

export const DEFAULT_MAP_PIN = `${BUCKET}DEFAULT_MAP_PIN.svg?alt=media&token=e49c329e-799d-419b-b36d-296507f93863`;
export const RED_SCOOTER = `${BUCKET}RED_SCOOTER.svg?alt=media&token=7cb7afe9-3582-4fa4-8d77-548356319f81`;

/** Local vendor badge: avoids the retired ePOSmatic Google Cloud SVG and works offline. */
export const POWERED_BY_LOGO = "/assets/branding/provided-by-starasoft.svg";
export { PLATFORM_WEBSITE } from "../lib/config";
